<template>
  <div>
    <b-modal centered no-close-on-backdrop no-close-on-esc v-model="modelPayInfoShow" @close="closePayModel"
             size="xl" hide-footer no-stacking>
      <template slot="modal-title">
        <div slot="header" class="bg-white border-0">
          <div class="row align-items-center">
            <div class="col-12">
              <h3 class="mb-0">ข้อมูลการรับเงิน
                <span @click="goToLinkManual()">
                            <i class="fas fa-info-circle fa-xs text-primary m-1" style="cursor: pointer;"
                               v-b-tooltip title="คู่มือวิธีการใช้ส่วนลดท้ายบิล">
                            </i>
                        </span>
              </h3>
            </div>
          </div>
        </div>
      </template>
      <card shadow type="secondary" class="m--4">
        <template>
          <form @submit.prevent>
            <div class>
              <div class="row">
                <div class="col-lg-12">
                  <div class="group-result">
                    <div class="price">
                      <h6>ยอดรวมทั้งหมด</h6>
                      <h1>
                        <template v-if="useDiscount">
                          <span class="text-muted number-discount px-2">{{totalPriceOrder | numFormat('0,0.00')}}</span>
                          <span>{{totalBalance | numFormat('0,0.00')}} </span>
                        </template>
                        <template v-else>
                          <span>{{totalPriceOrder | numFormat('0,0.00')}} </span>
                        </template>
                        <small>บาท</small>
                      </h1>
                    </div>
                  </div>
                  <hr class="my-4" />
                </div>
                <!--        自定义标准价        -->
<!--                <div class="col-lg-12">-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-5">-->
<!--                      <div class="switch-pos">-->
<!--                        <div class="d-flex align-items-center">-->
<!--                          <b-form-checkbox switch size="lg" v-model="useDiscount" @change="resetDiscount"></b-form-checkbox>-->
<!--                          <span>ส่วนลดท้ายบิล</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-lg-7">-->
<!--                      <b-form-radio-group class="custom-radio-discount" v-if="useDiscount" v-model="typeDiscount" @input="calculatePayment">-->
<!--                        <div class="row">-->
<!--                          <div class="col-lg-6 px-0" v-for="type in dataTypeDiscount" :key="type.key">-->
<!--                            <b-form-radio :value="type.key">{{type.title}}</b-form-radio>-->
<!--                          </div>-->
<!--                        </div>-->

<!--                      </b-form-radio-group>-->
<!--                    </div>-->
<!--                    <div class="col-lg-12 text-right text-muted text-xs" v-if="useDiscount">{{getDiscountTooltip(typeDiscount)}}</div>-->
<!--                  </div>-->
<!--                  <div class="price pt-2" v-if="useDiscount">-->
<!--                    <h6>ส่วนลด</h6>-->

<!--                    <b-form-input-->
<!--                        type="number"-->
<!--                        min="0.00"-->
<!--                        placeholder="0"-->
<!--                        class="input-discount hide-arrow"-->
<!--                        step=".01"-->
<!--                        v-model="numDiscount"-->
<!--                        :onkeypress="checkMaxDiscount"-->
<!--                        @change="checkMaxDiscount"-->
<!--                        @keyup="calculatePayment"-->
<!--                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 187'"-->
<!--                    >-->
<!--                    </b-form-input>-->
<!--                    <span>{{getUnit}}</span>-->
<!--                  </div>-->
<!--                  <hr class="my-4" />-->
<!--                </div>-->
                <div class="col-lg-12">
                  <div class="price">
                    <h6>รับเงิน</h6>
                    <!--           收银         -->
                    <base-input
                        formClasses="mb-0"
                        alternative
                        typeInput="number"
                        min="0.00"
                        v-on:keyup="calculatePayment"
                        placeholder="0"
                        input-classes="form-control-alternative hide-arrow"
                        v-model="cashMoney"
                        size="lg"
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 187'"
                    />
                  </div>
                  <hr class="my-4" />
                </div>
                <div class="col-lg-12">
                  <div class="group-result">
                    <div class="price">
<!--                      找零-->
                      <h6>เงินทอน</h6>
                      <h1>
                        {{changeMoney | numFormat('0,0.00')}}
                        <small>บาท</small>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4 w-100 text-right">
              <b-button variant="secondary" @click="closeCheckbill">ยกเลิก</b-button>
              <b-button
                  type="submit"
                  variant="success"
                  @click="Pay"
              >ยืนยัน
              </b-button>
            </div>
          </form>
        </template>
      </card>

<!--      <b-row>-->
<!--        <b-col>-->
<!--          &lt;!&ndash; 包裹支付信息 &ndash;&gt;-->
<!--          <div class="commodityPayInfo" v-if="payData.pkgs">-->
<!--            <div class="flex-between">-->
<!--              <p>包裹数量</p>-->
<!--              <p>{{payData.pkgs}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between">-->
<!--              <p>运费总计</p>-->
<!--              <p>{{ payData.userTotalFreightFee }} ฿</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.userTotalRemoteFee > 0">-->
<!--              <p>userTotalRemoteFee</p>-->
<!--              <p>{{payData.userTotalRemoteFee}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.userTotalSpeedFee > 0">-->
<!--              <p>userTotalSpeedFee</p>-->
<!--              <p>{{payData.userTotalSpeedFee}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.userTotalInsuranceFee > 0">-->
<!--              <p>userTotalInsuranceFee</p>-->
<!--              <p>{{payData.userTotalInsuranceFee}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.userTotalCodFee > 0">-->
<!--              <p>COD Fee（vat）</p>-->
<!--              <p>{{payData.userTotalCodFee}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; 商品支付信息 &ndash;&gt;-->
<!--          <div class="commodityPayInfo" v-if="payData.shops">-->
<!--            <div class="flex-between">-->
<!--              <p>商品数量</p>-->
<!--              <p>{{ payData.shops }}</p>-->
<!--            </div>-->
<!--            <div class="flex-between">-->
<!--              <p>商品费用</p>-->
<!--              <p>{{ payData.shopTotalFee }} ฿</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;标准价的配置&ndash;&gt;-->
<!--          <div>-->
<!--            &lt;!&ndash; 代理商应收&ndash;&gt;-->
<!--            <div class="totalPayInfo" style="border-top: 1px solid #EEEEEE;">-->
<!--              <div class="flex-between">-->
<!--                <p>代理商应收</p>-->
<!--                <p>{{ payData.userBillPayFee }} ฿</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; 优惠券&ndash;&gt;-->
<!--            <div class="totalPayInfo" >-->
<!--              <div class="flex-between">-->
<!--                <p>优惠码</p>-->
<!--                <p>{{ payData.userCouponFee}} ฿</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; 代理商实收 &ndash;&gt;-->
<!--            <div class="totalPayInfo" style="border-bottom: 1px solid #EEEEEE;">-->
<!--              <div class="flex-between">-->
<!--                <p>代理商实收</p>-->
<!--                <p>{{ payData.userRealPayFee}} ฿</p>-->
<!--              </div>-->
<!--            </div>-->


<!--          </div>-->
<!--        </b-col>-->
<!--        <b-col>-->
<!--          &lt;!&ndash; 包裹支付信息 &ndash;&gt;-->
<!--          <div class="commodityPayInfo" v-if="payData.pkgs">-->
<!--            <div class="flex-between">-->
<!--              <p>&nbsp;</p>-->
<!--            </div>-->
<!--            <div class="flex-between">-->
<!--              <p>运费扣款</p>-->
<!--              <p>{{ payData. agentTotalFreightFee}} ฿</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.agentTotalRemoteFee !== 0">-->
<!--              <p>agentTotalRemoteFee</p>-->
<!--              <p>{{payData.agentTotalRemoteFee}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.agentTotalSpeedFee !== 0">-->
<!--              <p>agentTotalSpeedFee</p>-->
<!--              <p>{{payData.agentTotalSpeedFee}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.agentTotalInsuranceFee !== 0">-->
<!--              <p>agentTotalInsuranceFee</p>-->
<!--              <p>{{payData.agentTotalInsuranceFee}}</p>-->
<!--            </div>-->
<!--            <div class="flex-between" v-if="payData.agentTotalCodFee !== 0">-->
<!--              <p>COD Fee（vat）</p>-->
<!--              <p>{{payData.agentTotalCodFee}}</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; 商品支付信息 &ndash;&gt;-->
<!--          <div class="commodityPayInfo" v-if="payData.shops">-->
<!--            <div class="flex-between">-->
<!--              <p>&nbsp;</p>-->
<!--            </div>-->
<!--            <div class="flex-between">-->
<!--              <p>商品扣款</p>-->
<!--              <p>0 ฿</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;标准价的配置&ndash;&gt;-->
<!--          <div>-->

<!--            &lt;!&ndash; total支付信息 代理商应收收&ndash;&gt;-->
<!--            <div class="totalPayInfo" style="border-top: 1px solid #EEEEEE;">-->
<!--              <div class="flex-between">-->
<!--                <p>代理商应扣款</p>-->
<!--                <p>{{ payData. agentBillFee}} ฿</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; total支付信息 代理商优惠&ndash;&gt;-->
<!--            <div class="totalPayInfo" >-->
<!--              <div class="flex-between">-->
<!--                <p>优惠券</p>-->
<!--                <p>{{ payData.agentCouponFee *1}} ฿</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; total支付信息 代理商实收&ndash;&gt;-->
<!--            <div class="totalPayInfo">-->
<!--              <div class="flex-between">-->
<!--                <p>实际扣款</p>-->
<!--                <p>{{ payData.agentRealPayFee*1 }} ฿</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; 合计返利&ndash;&gt;-->
<!--            <div class="totalPayInfo" style="border-top: 1px solid #EEEEEE;">-->
<!--              <div class="flex-between">-->
<!--                <p>合计返利</p>-->
<!--                <p>{{ payData.agentRebateFee }} ฿</p>-->
<!--              </div>-->
<!--            </div>-->


<!--          </div>-->
<!--        </b-col>-->
<!--      </b-row>-->

<!--      <div style="display: flex;align-items: center;justify-content: flex-end">-->
<!--        <b-button type="submit">Cancel</b-button>-->
<!--        <b-button type="reset" variant="primary" @click="Pay">Pay</b-button>-->
<!--      </div>-->
    </b-modal>
  </div>
</template>
<script>
import {getTaxInfo, payOrderPriceBatch} from "@/api/express";

export default{
  props:{
    cashNumberInfo:{
      type:Object,
      default:() => {},
    },
    CASH_NUM:{
      type:String,
      default:'',
    },
  },
  data(){
    return {
      modelPayInfoShow:false,
      payData:{},
      cashMoney:'',
      changeMoney:'',
      useDiscount: false,
      totalPriceOrder:'',
      totalBalance:''
    }
  },
  created() {
    console.log(this.payData)
  },
  methods:{
    closePayModel(){
      this.modelPayInfoShow = false
    },
    showPayModel(params){
      console.log(params)
      this.payData = params
      this.totalPriceOrder = params.userBillPayFee
      this.modelPayInfoShow = true
    },
    calculatePayment() {
      this.totalPriceOrder = Number(parseFloat(this.totalPriceOrder).toFixed(2));
      if (this.cashMoney >= this.totalPriceOrder){
        this.changeMoney = (this.cashMoney - this.totalPriceOrder).toFixed(2)
      }else{
        this.changeMoney = 0.00
      }

    },
    Pay(){
      let params = {
        orderIds: this.payData.orderIds,
        pkgIds: this.payData.pkgIds,
        servicesIds:this.payData.servicesIds
      }
      payOrderPriceBatch(params)
          .then((res) => {
            console.log(res)
            let orderParams = {
              agentId: this.$store.state.loginUser.agentId,
              ids: [...this.payData.orderIds, ...this.payData.pkgIds],
              shopType:this.payData.shops > 0 ? 0 : 1,
              isTax: 0, //是否可以打印发票
              printType: 2, //打印类型为回执
              receiptSize: this.$store.state.loginUser.options.PRINT_RECEIPT === '58'?'1':'2',
              receivingAmount: this.cashMoney?this.cashMoney:'',
              changeAmount: this.changeMoney?this.changeMoney:'0.00'
            }
            this.modelPayInfoShow = false
            this.$emit('fnGetPosRecentlyList')
            return console.log(orderParams)
            let param = JSON.stringify(orderParams)
            try {
              let url = `https://preams.mysave.co/print?params=${secret.aesEncryptCBC(param)}`
              window.open(url)
              location.reload()
            } catch (e) {
              console.log('error')
            }
          })
    },
    goToLinkManual(){
      window.open(`https://docs.google.com/document/d/1jKw23wtwB-ZUVC84eUqTL8iPe1ZUEQk-xPeS0j3ggmQ/edit?usp=sharing`, '_blank')
    },
    closeCheckbill() {
      this.modelPayInfoShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-between{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  p{
    margin:0;
    font-size: 18px;
    line-height: 36px;
  }
}
.totalPayInfo{
  .el-dialog{
    border-radius: 16px;
    border-top: 2px solid #2878FF;
  }
  .el-dialog__title{
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }
  .commodityPayInfo{
    padding: 8px 0;
    line-height: 32px;
  }
  .discountPayInfo{
    background-color: #f7faff;
    padding: 8px 16px;
    line-height: 32px;
    border-radius: 8px;
    margin-top:8px;
    color: #2878FF;
  }
  .totalPayInfo{
    padding: 8px 0;
    line-height: 32px;
  }
  .agentPayInfo{
    color: #FF4D4F;
    line-height: 32px;
  }
}
</style>
